/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core';

const CreateCourseDialogViewStyles = makeStyles((theme: Theme) =>
	createStyles({
		paper: {
			maxWidth: '360px',
		},
		dialogTitle: {
			display: 'flex',
			justifyContent: 'space-between',
			fontSize: '1.1rem',
			fontFamily: theme.typography.fontFamilyBold,
		},
		label: {
			marginBottom: 2,
			fontSize: 'small',
			fontFamily: theme.typography.fontFamilyBold,
			color: theme.palette.common.black,
		},
		dialogActions: {
			padding: theme.spacing(2, 3, 3),
			'& button': {
				width: '100%',
			},
		},
		closeButton: {
			color: '#3A3A3A',
			opacity: '0.6',
			'&:hover': {
				cursor: 'pointer',
			},
		},
		emojiPicker: {
			display: 'flex',
			justifyContent: 'center',
			lineHeight: '40px',
			borderRadius: '4px',
			border: '1px solid #bcbcbc',
			height: '40px',
			'&:hover': {
				borderColor: '#1e1e1e',
				cursor: 'pointer',
			},
			'& .emoji-mart-emoji': {
				display: 'flex',
				alignItems: 'center',
			},
		},
		startDatePicker: {
			marginTop: '0',
			width: '100%',
		},
		infoIconBox: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		infoBox: {
			padding: theme.spacing(0, 3),
			fontSize: 13,
		},
	})
);

export default CreateCourseDialogViewStyles;
